  function selectedVarint() {
    var slectedId = $(".single-product-variant").val();
    var url = new URL(window.location.href);
    url.searchParams.set("variant", slectedId);
    window.history.replaceState({}, "", url);
  }

function matchVariant() {
    if (!$(".variant-option-value").length) {
      return;
    }
    var foundVariant = 0;
    var updateValue = "";
    $(".variant-option-value:checked").each(function () {
      updateValue += (updateValue ? " / " : "") + $(this).val();
    })
  
    $(".single-product-variant option").each(function () {
      var optionValue = $(this).text().trim();
      if (updateValue.toLowerCase() == optionValue.toLowerCase()) {
        foundVariant ++
        $(this).prop("selected", true);
        var variant__available = $(this).attr("data-variant-available");
        var prod_price = $(this).attr("var-price");
        console.log(foundVariant);
        $('.product__price').each(function () {
  var label = $(this).attr('data-price-label');
  if (label) {
    $(this).html(label + ' <span class="product__price-value">' + prod_price + '</span>');
  } else {
    $(this).html(prod_price);
  }
});

        $('.product__mobi-price span').html(prod_price);
        if(variant__available == 'false'){
            $(".single-product-atc").addClass("btn_disabled")
            $(".single-product-atc").text("Sold out");
        }else{
            $(".single-product-atc").removeClass("btn_disabled"); 
            $(".single-product-atc").text("Add to cart");
        }
        return true;
      }
    });
      
        if(foundVariant != 1){
            $(".single-product-atc").addClass("btn_disabled")
            $(".single-product-atc").text("Sold out");
        }
  
  }





function sectionRedering() {
  fetch("?section_id=cart-drawer-new")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".cart-drawer__inner", cart__html);
      $(".cart-drawer__inner").replaceWith(render__html);
    });

  // header 
  fetch("?section_id=header-new")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".header__cart p", cart__html);
      $(".header__cart p").replaceWith(render__html);
    });
$('body').addClass('cart-drawer-open');
}

function validateProductInputs() {
  var isValid = true;

  $('.product__choose input.input-width, .product__choose input.input-depth').each(function () {
    var $input = $(this);
    var $choose = $input.closest('.product__choose');
    var $item = $input.closest('.product__choose-item');
    var type = $item.data('type');

    var widthValues = JSON.parse($choose.attr('data-width-values') || '[]');
    var depthValues = JSON.parse($choose.attr('data-depth-values') || '[]');
    if (!widthValues.length || !depthValues.length) return;

    var maxWidth = Math.max.apply(null, widthValues);
    var minWidth = Math.min.apply(null, widthValues);
    var maxDepth = Math.max.apply(null, depthValues);
    var minDepth = Math.min.apply(null, depthValues);
    var currentVal = parseFloat($input.val(), 10);

    $input.removeClass('input-error');
    $input.closest('.product__choose-item').find('.error-message').remove();

    if (isNaN(currentVal)) {
      isValid = false;
      $input.addClass('input-error');
      $input.closest('.product__choose-item').append('<div class="error-message">Please enter a valid number</div>');
      return;
    }

    var errorMsg = '';
    if (type === 'width') {
      if (currentVal > maxWidth) {
        errorMsg = 'Maximum width is ' + maxWidth + 'cm';
        isValid = false;
      } else if (currentVal < minWidth) {
        errorMsg = 'Minimum width is ' + minWidth + 'cm';
        isValid = false;
      }
    }
    if (type === 'depth') {
      if (currentVal > maxDepth) {
        errorMsg = 'Maximum depth is ' + maxDepth + 'cm';
        isValid = false;
      } else if (currentVal < minDepth) {
        errorMsg = 'Minimum depth is ' + minDepth + 'cm';
        isValid = false;
      }
    }

    if (errorMsg) {
      $input.addClass('input-error');
      $input.closest('.product__choose-item').append('<div class="error-message">' + errorMsg + '</div>');
    }
  });

  return isValid;
}

function buildMainProductProperties($form) {
  var properties = {};
  $form.find('[name^="properties["]').each(function () {
    var $field = $(this);
    var type = ($field.attr('type') || '').toLowerCase();
    if ((type === 'radio' || type === 'checkbox') && !$field.is(':checked')) return;

    var rawName = $field.attr('name') || '';
    var key = rawName.replace(/^properties\[/, '').replace(/\]$/, '');
    if (!key) return;

    properties[key] = $field.val();
  });
  return properties;
}

function buildUpsellItems($form) {
  var items = [];
  $form.closest('.product__wrap').find('.upsell_input:checked').each(function () {
    var $checkbox = $(this);
    var variantId = parseInt($checkbox.data('upsell-variant'), 10);
    if (!variantId) return;

    var qty = parseInt($checkbox.closest('.product__picks-item').find('.upsell-qty-input').val(), 10);
    if (isNaN(qty) || qty < 1) qty = 1;

    items.push({
      id: variantId,
      quantity: qty
    });
  });
  return items;
}
function buildLinkedAddonItem($form) {
  var $selected = $form.find('input[name="rail_variant_id"]:checked').first();
  if (!$selected.length) return null;

  var variantId = parseInt($selected.val(), 10);
  if (!variantId) return null;

  var quantityMode = $.trim($form.find('input[name="properties[_linked_addon_quantity_mode]"]').val() || 'single');
  var addonQty = 1;

  if (quantityMode === 'match_main_quantity') {
    addonQty = parseInt($form.find('input[name="quantity"]').first().val(), 10);
    if (isNaN(addonQty) || addonQty < 1) addonQty = 1;
  }

  return {
    item: {
      id: variantId,
      quantity: addonQty
    },
    title: $.trim($selected.attr('data-rail-title') || '')
  };
}




function buildMtmOptionItem($form) {
  var $selected = $form.find('.mtm-option-input:checked').first();
  if (!$selected.length) return null;

  var resolvedOption = resolveMtmOptionVariant($selected, $form.closest('.product__wrap'));
  if (!resolvedOption || !resolvedOption.id) return null;

  return {
    item: {
      id: resolvedOption.id,
      quantity: 1
    },
    title: $.trim($selected.data('option-title') || '')
  };
}


function setExactMtmThreeProperty($form) {
  var $choose = $form.closest('.product__wrap').find('.product__choose-mtm-three').first();
  if (!$choose.length) return;

  var exactWidth = $.trim($choose.find('.input-width').first().val() || '');
  var exactDepth = $.trim($choose.find('.input-depth').first().val() || '');
  if (!exactWidth || !exactDepth) return;

  $form.find('.exact-prop').first().val(exactWidth + 'CM / ' + exactDepth + 'CM');
}

function setExactCustomLengthProperty($form) {
  var $scope = $form.closest('.product__wrap');
  var $config = $scope.find('.product-config--custom-length-variants').first();
  if (!$config.length) return;

  var exactLength = $.trim($config.find('.input-custom-length').val() || '');
  if (!exactLength) return;

  $config.find('.input-length-exact').val(exactLength + 'cm');
}

 $('.single-product-atc').click(function(e){
  e.preventDefault();

  const form = $(this).closest('.single-product')[0] || document.querySelector('.single-product');
  if (!form) return;

  var $form = $(form);
  setExactMtmThreeProperty($form);
  setExactCustomLengthProperty($form);


  if (!validateProductInputs()) {
    var $firstError = $('.input-error').first();
    if ($firstError.length) {
      $('html, body').animate({
        scrollTop: $firstError.offset().top - 100
      }, 300);
    }
    return;
  }


  if (!form.reportValidity()) return;


  var $scope = $form.closest('.product__wrap');

  var variantId = parseInt($form.find('.single-product-variant').val(), 10);
  if (!variantId) return;

  var mainQty = parseInt($form.find('input[name="quantity"]').first().val(), 10);
  if (isNaN(mainQty) || mainQty < 1) mainQty = 1;

  var mainItem = {
    id: variantId,
    quantity: mainQty,
    properties: buildMainProductProperties($form)
  };

  var items = [mainItem].concat(buildUpsellItems($form));
  var linkedAddon = buildLinkedAddonItem($form);
if (linkedAddon) {
  items.push(linkedAddon.item);
  mainItem.properties = mainItem.properties || {};
  if (linkedAddon.title) {
    mainItem.properties['Selected add-on'] = linkedAddon.title;
  }
}


  var $chooseMtmThree = $scope.find('.product__choose-mtm-three');
  if ($chooseMtmThree.length) {
    var $railSelect = $chooseMtmThree.find('.third-option-select');
    var railVariantId = parseInt($railSelect.val(), 10);
    var railTitle = $.trim($railSelect.find('option:selected').text());

    if (railTitle) {
      mainItem.properties = mainItem.properties || {};
      mainItem.properties['Rail height'] = railTitle;
      $scope.find('.rail-height-prop').val(railTitle);
    }

    if (!isNaN(railVariantId) && railVariantId > 0) {
      items.push({
        id: railVariantId,
        quantity: 1
      });
    }
  }
    var mtmOption = buildMtmOptionItem($form);
  if (mtmOption) {
    items.push(mtmOption.item);
    mainItem.properties = mainItem.properties || {};
    if (mtmOption.title) {
      mainItem.properties['Selected option'] = mtmOption.title;
    }
  }


  var payload = { items: items };

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    contentType: 'application/json; charset=UTF-8',
    data: JSON.stringify(payload),
    success: function() {
      sectionRedering();
    },
    error: 'addToCartFail'
  });
});



// increment quantity in cart drawer
function increment(el) {
  var input = el.previousElementSibling;
  var value = parseInt(input.value);
  console.log(value)
  value = isNaN(value) ? 0 : value
  value++;
  input.value = value;
  changeQuantity(input);

}
// decrement quantity in cart drawer
function decrement(el) {
  var input = el.nextElementSibling;
  var value = parseInt(input.value);
  if (value > 0) {
    value = isNaN(value) ? 0 : value;
    value--;
    input.value = value;
    changeQuantity(input);
  }
}

function changeQuantity(input) {

  var quantity = $(input).val();
  var data_line = $(input).attr("data-line");
  var data = {
    "line": data_line,
    "quantity": quantity
  };
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: data,
    success: function (data) {
      console.log(data);
      sectionRedering();
    },
    error: function (err) {
      console.log("Error from quantity update")
    }
  })


}


function removeItem(event, el) {
  event.preventDefault();
  var data_line = $(el).attr("data-line");
  console.log(data_line)
  var deleteData = {
    "line": data_line,
    "quantity": 0
  };

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: deleteData,
    success: function (data) {

      sectionRedering();
    }
  })
}


 $(".variant-option-value").change(function () {
  matchVariant();
  selectedVarint();
})
matchVariant();



$(document).on('change', '.upsell_input', function(){
  var $item = $(this).closest('.product__picks-item');
  var $qty = $item.find('.upsell-qty-input');
  if (!$qty.length) return;
  $qty.prop('disabled', !$(this).is(':checked'));
});
$(document).on('click', '.upsell-qty-minus, .upsell-qty-plus', function () {
  var $btn = $(this);
  var $item = $btn.closest('.product__picks-item');
  var $input = $item.find('.upsell-qty-input');
  var $checkbox = $item.find('.upsell_input');

  var current = parseInt($input.val(), 10);
  if (isNaN(current) || current < 0) current = 0;

  if ($btn.hasClass('upsell-qty-minus')) {
    current = Math.max(0, current - 1);
  } else {
    current = current + 1;
  }

  $input.val(current);
  $checkbox.prop('checked', current > 0);
});

$(document).on('input change', '.upsell-qty-input', function () {
  var $input = $(this);
  var $item = $input.closest('.product__picks-item');
  var $checkbox = $item.find('.upsell_input');

  var qty = parseInt($input.val(), 10);
  if (isNaN(qty) || qty < 0) qty = 0;

  $input.val(qty);
  $checkbox.prop('checked', qty > 0);
});








// Filtering JS


  var selectors = {
    wrapper: '.collection__inner',
    form: '#CollectionFiltersForm',
    applyBtn: '[data-filters-submit]',
    watchedInputs: '#CollectionFiltersForm input',
    // If your pagination markup differs, we’ll adjust this later.
    paginationLinks: '.pagination a, [data-pagination] a, .pagination-wrapper a'
  };

  function log() {
    // comment this out later
    console.log.apply(console, ['[CollectionAjax]'].concat([].slice.call(arguments)));
  }

  function setLoading(isLoading) {
    $(selectors.wrapper).toggleClass('is-loading', !!isLoading);
  }

  function buildQueryFromForm() {
    var $form = $(selectors.form);
    if (!$form.length) return '';

    var data = $form.serializeArray().filter(function (item) {
      return item.value !== null && item.value !== '';
    });

    return $.param(data);
  }

  function getBaseCollectionUrl() {
    var action = $(selectors.form).attr('action');
    return action || window.location.pathname;
  }

  function renderCollectionInner(url, pushState) {
    log('Fetching:', url);
    setLoading(true);

    return $.ajax({ url: url, type: 'GET', dataType: 'html' })
      .done(function (html) {
        var $response = $('<div/>').append($.parseHTML(html));
        var $newInner = $response.find(selectors.wrapper).first();

        if (!$newInner.length) {
          log('Could not find .collection__inner in response. Falling back.');
          window.location.href = url;
          return;
        }

        $(selectors.wrapper).replaceWith($newInner);

        if (pushState) {
          window.history.pushState({ url: url }, '', url);
        }

        bindEvents(); // rebind after replace
        log('Replaced .collection__inner successfully.');
        singleScrollReveal();
      // $('body').removeClass('filter-open');
      })
      .fail(function (xhr) {
        console.warn('[CollectionAjax] AJAX failed:', xhr && xhr.status);
        window.location.href = url;
      })
      .always(function () {
        setLoading(false);
      });
      
  }

  function applyFilters(pushState) {
    var baseUrl = getBaseCollectionUrl();
    var qs = buildQueryFromForm();
    var url = qs ? (baseUrl + '?' + qs) : baseUrl;
    return renderCollectionInner(url, pushState);
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function bindEvents() {
    // Verify elements exist
    log('Bind check:', {
      form: !!document.querySelector(selectors.form),
      wrapper: !!document.querySelector(selectors.wrapper)
    });

    // Remove old handlers
    $(document)
      .off('change.collectionFilters', selectors.watchedInputs)
      .off('click.collectionFilters', selectors.applyBtn)
      .off('click.collectionFilters', selectors.paginationLinks)
      .off('input.collectionFilters', selectors.form + ' input[type="number"]');

    // // Checkbox/radio change
    // $(document).on('change.collectionFilters', selectors.watchedInputs, function () {
    //   var type = (this.getAttribute('type') || '').toLowerCase();
    //   log('Input changed:', this.name, this.value, type);

    //   if (type === 'number') return;
    //   applyFilters(true);
    // });

    // // Price range (debounced)
    // $(document).on(
    //   'input.collectionFilters',
    //   selectors.form + ' input[type="number"]',
    //   debounce(function () {
    //     log('Price input typing...');
    //     applyFilters(true);
    //   }, 500)
    // );

    // Apply button
    $(document).on('click.collectionFilters', selectors.applyBtn, function (e) {
      e.preventDefault();
      log('Apply button clicked');
      applyFilters(true);
      $('body').removeClass('filter-open');
    });

    



    // Pagination
    $(document).on('click.collectionFilters', selectors.paginationLinks, function (e) {
      var href = $(this).attr('href');
      if (!href) return;
      e.preventDefault();
      log('Pagination clicked:', href);
      renderCollectionInner(href, true);
    });
  }

  window.addEventListener('popstate', function (event) {
    var url = (event.state && event.state.url) ? event.state.url : window.location.href;
    log('Popstate:', url);
    renderCollectionInner(url, false);
  });

  $(function () {
    log('Init running. jQuery:', $.fn.jquery);
    bindEvents();
  });




  // Clear all filters
    $(document).on('click.collectionFilters', '.filtar__selected-delete', function (e) {
      e.preventDefault();
      clearAllFilters();
    });
    
    function clearAllFilters() {
      var baseUrl = getBaseCollectionUrl(); // collection.url
      return renderCollectionInner(baseUrl, true);
    }















    // Alternative product variant selector
  function closestNumber(arr, val) {
    val = parseFloat(val, 10);
    if (isNaN(val)) return arr[0];

    var best = arr[0], diff = Math.abs(val - best);
    for (var i = 1; i < arr.length; i++) {
      var d = Math.abs(val - arr[i]);
      if (d < diff) { diff = d; best = arr[i]; }
    }
    return best;
  }

  function updateSelect($choose) {
    var foundVariant = 0;
    var $select = $('.single-product-variant');
    if (!$select.length) return;

    // var depth = parseFloat($choose.find('[data-type="depth"] input').val(), 10);
    // var width = parseFloat($choose.find('[data-type="width"] input').val(), 10);
    var depth = parseFloat($choose.find('.hidden-input-depth').val(), 10);
    var width = parseFloat($choose.find('.hidde-input-width').val(), 10);
    if (isNaN(depth) || isNaN(width)) return;

    var target = (width + 'cm / ' + depth + 'cm').toLowerCase();

    var found = null;
    $select.find('option').each(function () {
      if ($.trim($(this).text()).toLowerCase() === target) {
        foundVariant ++
        found = $(this).val();
        $(this).prop("selected", true);
        var variant__available = $(this).attr("data-variant-available");
        var prod_price = $(this).attr("var-price");
        console.log(foundVariant);
        $('.product__price').each(function () {
  var label = $(this).attr('data-price-label');
  if (label) {
    $(this).html(label + ' <span class="product__price-value">' + prod_price + '</span>');
  } else {
    $(this).html(prod_price);
  }
});

        $('.product__mobi-price span').html(prod_price);
        if(variant__available == 'false'){
            $(".single-product-atc").addClass("btn_disabled")
            $(".single-product-atc").text("Sold out");
        }else{
            $(".single-product-atc").removeClass("btn_disabled"); 
            $(".single-product-atc").text("Add to cart");
        }
        return false;
      }
    });
if(foundVariant != 1){
            $(".single-product-atc").addClass("btn_disabled")
            $(".single-product-atc").text("Sold out");
        }
    if (found) $select.val(found).trigger('change');
  }

  var propOne = $('[data-type="width"] input').val();
  var propTwo = $('[data-type="depth"] input').val();

  $(document).on('input', '.product__choose input', function () {
    var $choose = $(this).closest('.product__choose');
    if ($choose.hasClass('product__choose-mtm-three')) return;
    var widthValues = JSON.parse($choose.attr('data-width-values') || '[]');
    var depthValues = JSON.parse($choose.attr('data-depth-values') || '[]');
    
    if(this.className == 'input-width'){
       propOne = $('[data-type="width"] input').val();
    }
    if(this.className == 'input-depth'){
       propTwo = $('[data-type="depth"] input').val();
    }
    var myProp = propOne + propTwo;
    console.log('Property = ' + myProp);
    $('.exact-prop').val(propOne +'CM / ' + propTwo + 'CM');

    if (!widthValues.length || !depthValues.length) return;

    var $item = $(this).closest('.product__choose-item');
    var type = $item.data('type');

    // if (type === 'width') $(this).val(closestNumber(widthValues, $(this).val()));
    // if (type === 'depth') $(this).val(closestNumber(depthValues, $(this).val()));
    if (type === 'width') $('.hidde-input-width').val(closestNumber(widthValues, $(this).val()));
    if (type === 'depth') $('.hidden-input-depth').val(closestNumber(depthValues, $(this).val()));

    updateSelect($choose);
  });

  $(function () {
    $('.product__choose').each(function () {
      var $choose = $(this);
      if ($choose.hasClass('product__choose-mtm-three')) return;
      updateSelect($choose);
    });
  });

  function formatPounds(cents) {
  cents = parseInt(cents, 10) || 0;
  return '£' + (cents / 100).toFixed(2);
}
function getMtmThreeDimensions($scope) {
  var $choose = $scope.find('.product__choose-mtm-three').first();
  if (!$choose.length) return null;

  var width = parseFloat($choose.find('.hidde-input-width, .hidden-input-width').first().val(), 10);
  var depth = parseFloat($choose.find('.hidden-input-depth').first().val(), 10);
  if (isNaN(width) || isNaN(depth)) return null;

  return { width: width, depth: depth };
}

function parseOptionVariants($input) {
  var rawVariants = $input.attr('data-option-variants');
  if (!rawVariants) return [];

  try {
    var parsed = JSON.parse(rawVariants);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.warn('Failed to parse MTM option variants', error);
    return [];
  }
}

function resolveMtmOptionVariant($input, $scope) {
  if (!$input || !$input.length) return null;

  var variants = parseOptionVariants($input);
  var dimensions = getMtmThreeDimensions($scope);
  var fallbackId = parseInt($input.attr('data-variant-id'), 10) || 0;
  var fallbackPrice = parseInt($input.attr('data-option-price'), 10) || 0;

  if (!variants.length || !dimensions) {
    return { id: fallbackId, price: fallbackPrice };
  }

  var matched = null;
  for (var i = 0; i < variants.length; i++) {
    var variant = variants[i];
    var parts = $.trim(variant.title || '').split('/').map(function (part) { return $.trim(part); });
    if (parts.length < 2) continue;

    var variantWidth = parseCentimeter(parts[0]);
    var variantDepth = parseCentimeter(parts[1]);
    if (variantWidth === dimensions.width && variantDepth === dimensions.depth) {
      matched = variant;
      break;
    }
  }

  if (!matched) {
    for (var j = 0; j < variants.length; j++) {
      if (variants[j].available) {
        matched = variants[j];
        break;
      }
    }
  }

  if (!matched && variants.length) matched = variants[0];
  if (!matched) return { id: fallbackId, price: fallbackPrice };

  var resolved = {
    id: parseInt(matched.id, 10) || fallbackId,
    price: parseInt(matched.price, 10) || 0
  };

  $input.attr('data-variant-id', resolved.id);
  $input.attr('data-option-price', resolved.price);

  return resolved;
}

function updateMtmThreePrice($choose) {
  var $scope = $choose.closest('.product__wrap');
  var $variantSelect = $scope.find('.single-product-variant').first();

  var shelfPrice = parseInt($variantSelect.find('option:selected').attr('data-variant-price'), 10) || 0;
  var qty = parseInt($scope.find('input[name="quantity"]').first().val(), 10);
  if (isNaN(qty) || qty < 1) qty = 1;

  var railPrice = parseInt($choose.find('.third-option-select option:selected').attr('data-rail-price'), 10) || 0;

   var $selectedOption = $scope.find('.mtm-option-input:checked').first();
  if (!$selectedOption.length) $selectedOption = $scope.find('.mtm-option-input').first();
  var resolvedOption = resolveMtmOptionVariant($selectedOption, $scope);
  var optionPrice = resolvedOption ? resolvedOption.price : 0;


  var total = (shelfPrice * qty) + railPrice + optionPrice;

  $scope.find('.product__price').text(formatPounds(total));
  $scope.find('.product__mobi-price span').text(formatPounds(total));

  var railTitle = $choose.find('.third-option-select option:selected').text();
  $scope.find('.rail-height-prop').val(railTitle || '');
}

function updateMtmThreeSelect($choose) {
  var $scope = $choose.closest('.product__wrap');
  var $select = $scope.find('.single-product-variant').first();
  if (!$select.length) return;

  var depth = parseFloat($choose.find('.hidden-input-depth').val(), 10);
  var width = parseFloat($choose.find('.hidde-input-width, .hidden-input-width').first().val(), 10);
  if (isNaN(depth) || isNaN(width)) return;

  var foundVariant = 0;
  var found = null;

  $select.find('option').each(function () {
    var parts = $.trim($(this).text()).split('/').map(function (part) { return $.trim(part); });
    if (parts.length < 2) return;

    var variantWidth = parseCentimeter(parts[0]);
    var variantDepth = parseCentimeter(parts[1]);
    if (variantWidth !== width || variantDepth !== depth) return;

    foundVariant++;
    found = $(this).val();
    $(this).prop('selected', true);

    var variant__available = $(this).attr('data-variant-available');
    if (variant__available == 'false') {
      $('.single-product-atc').addClass('btn_disabled').text('Sold out');
    } else {
      $('.single-product-atc').removeClass('btn_disabled').text('Add to cart');
    }
    return false;
  });

  if (foundVariant != 1) {
    $('.single-product-atc').addClass('btn_disabled').text('Sold out');
  }

  if (found) $select.val(found).trigger('change');
  updateMtmThreePrice($choose);
}

function syncMtmThreeQty($choose, qty) {
  qty = parseInt(qty, 10);
  if (isNaN(qty) || qty < 1) qty = 1;

  var $scope = $choose.closest('.product__wrap');
  $choose.find('.mtm-three-qty-input').val(qty);
  $scope.find('input[name="quantity"]').first().val(qty);
  updateMtmThreePrice($choose);
}

$(document).on('input', '.product__choose-mtm-three .input-width, .product__choose-mtm-three .input-depth', function () {
  var $choose = $(this).closest('.product__choose-mtm-three');
  var widthValues = JSON.parse($choose.attr('data-width-values') || '[]');
  var depthValues = JSON.parse($choose.attr('data-depth-values') || '[]');
  if (!widthValues.length || !depthValues.length) return;




  var $item = $(this).closest('.product__choose-item');
  var type = $item.data('type');
  if (type === 'width') $choose.find('.hidde-input-width, .hidden-input-width').val(closestNumber(widthValues, $(this).val()));
if (type === 'depth') $choose.find('.hidden-input-depth').val(closestNumber(depthValues, $(this).val()));

var widthProp = $choose.find('.hidde-input-width, .hidden-input-width').first().val();
var depthProp = $choose.find('.hidden-input-depth').val();
$choose.closest('.product__wrap').find('.exact-prop').first().val(widthProp + 'CM / ' + depthProp + 'CM');


  updateMtmThreeSelect($choose);
});
$(document).on('blur', '.product__choose-mtm-three .input-width, .product__choose-mtm-three .input-depth', function () {
  var $choose = $(this).closest('.product__choose-mtm-three');
  var widthValues = JSON.parse($choose.attr('data-width-values') || '[]');
  var depthValues = JSON.parse($choose.attr('data-depth-values') || '[]');
  if (!widthValues.length || !depthValues.length) return;

  var $item = $(this).closest('.product__choose-item');
  var type = $item.data('type');

  function clamp(val, arr) {
    var min = Math.min.apply(null, arr);
    var max = Math.max.apply(null, arr);
    return Math.min(max, Math.max(min, val));
  }

  if (type === 'width') {
    var rawW = parseFloat($(this).val());
    if (!isNaN(rawW)) {
      var clampedW = clamp(rawW, widthValues);
      $(this).val(clampedW);
      $choose.find('.hidde-input-width, .hidden-input-width').val(closestNumber(widthValues, clampedW));
    }
  }

  if (type === 'depth') {
    var rawD = parseFloat($(this).val());
    if (!isNaN(rawD)) {
      var clampedD = clamp(rawD, depthValues);
      $(this).val(clampedD);
      $choose.find('.hidden-input-depth').val(closestNumber(depthValues, clampedD));
    }
  }

  updateMtmThreeSelect($choose);
});

$(document).on('click', '.product__choose-mtm-three .mtm-three-qty-minus, .product__choose-mtm-three .mtm-three-qty-plus', function () {
  var $choose = $(this).closest('.product__choose-mtm-three');
  var current = parseInt($choose.find('.mtm-three-qty-input').val(), 10);
  if (isNaN(current) || current < 1) current = 1;

  if ($(this).hasClass('mtm-three-qty-minus')) current = Math.max(1, current - 1);
  else current = current + 1;

  syncMtmThreeQty($choose, current);
});

$(document).on('input change', '.product__choose-mtm-three .mtm-three-qty-input', function () {
  var $choose = $(this).closest('.product__choose-mtm-three');
  syncMtmThreeQty($choose, $(this).val());
});

$(document).on('change', '.product__choose-mtm-three .third-option-select', function () {
  var $choose = $(this).closest('.product__choose-mtm-three');
  var $scope = $choose.closest('.product__wrap');
  var railTitle = $(this).find('option:selected').text();

  $scope.find('.rail-height-prop').val(railTitle || '');
  updateMtmThreePrice($choose);
});


$(function () {
  $('.product__choose-mtm-three').each(function () {
    var $choose = $(this);
    var widthValues = JSON.parse($choose.attr('data-width-values') || '[]');
    var depthValues = JSON.parse($choose.attr('data-depth-values') || '[]');

    if (widthValues.length) {
      $choose.find('.hidde-input-width, .hidden-input-width').val(closestNumber(widthValues, $choose.find('.input-width').val()));
    }
    if (depthValues.length) {
      $choose.find('.hidden-input-depth').val(closestNumber(depthValues, $choose.find('.input-depth').val()));
    }

   var widthProp = $choose.find('.input-width').val();
var depthProp = $choose.find('.input-depth').val();

$choose.closest('.product__wrap').find('.exact-prop').first().val(widthProp + 'CM / ' + depthProp + 'CM');

    syncMtmThreeQty($choose, 1);
    updateMtmThreeSelect($choose);
  });
});


  // Fixed-depth made-to-measure selector:
  // option1 = width input, option2/3 = dropdown selectors
  function normalizeText(value) {
    return $.trim(String(value || '')).toLowerCase();
  }

  function parseCentimeter(value) {
    var numeric = parseFloat(String(value || '').toLowerCase().replace('cm', '').trim(), 10);
    return isNaN(numeric) ? null : numeric;
  }

  function updateFixedDepthSelect($choose) {
    var $scope = $choose.closest('.product__wrap');
    var $select = $scope.find('.single-product-variant').first();
    if (!$select.length) return;

    var width = parseFloat($choose.find('.hidden-input-width').val(), 10);
    if (isNaN(width)) return;

    var selectedOptions = [];
    var hasMissingOption = false;

    $choose.find('.fixed-option-select').each(function () {
      var optionValue = $(this).val();
      if (!optionValue) {
        hasMissingOption = true;
        return false;
      }
      selectedOptions.push(normalizeText(optionValue));
    });

    if (hasMissingOption) return;

    var foundVariant = 0;
    var found = null;
    $select.find('option').each(function () {
      var parts = $.trim($(this).text()).split('/').map(function (part) { return $.trim(part); });
      if (!parts.length) return;

      var variantWidth = parseCentimeter(parts[0]);
      if (variantWidth !== width) return;

      var matches = true;
      for (var i = 0; i < selectedOptions.length; i++) {
        if (normalizeText(parts[i + 1]) !== selectedOptions[i]) {
          matches = false;
          break;
        }
      }

      if (matches) {
        foundVariant++;
        found = $(this).val();
        $(this).prop('selected', true);

        var variant__available = $(this).attr("data-variant-available");
        var prod_price = $(this).attr("var-price");
        $('.product__price').each(function () {
          var label = $(this).attr('data-price-label');
          if (label) {
            $(this).html(label + ' <span class="product__price-value">' + prod_price + '</span>');
          } else {
            $(this).html(prod_price);
          }
        });

        $('.product__mobi-price span').html(prod_price);
        if (variant__available == 'false') {
          $(".single-product-atc").addClass("btn_disabled");
          $(".single-product-atc").text("Sold out");
        } else {
          $(".single-product-atc").removeClass("btn_disabled");
          $(".single-product-atc").text("Add to cart");
        }
        return false;
      }
    });

    if (foundVariant != 1) {
      $(".single-product-atc").addClass("btn_disabled");
      $(".single-product-atc").text("Sold out");
    } else {
      if (found) $select.val(found).trigger('change');
      selectedVarint();
    }
  }

  $(document).on('input change blur', '.product__choose-fixed-depth .input-width', function () {
    var $choose = $(this).closest('.product__choose-fixed-depth');
    var widthValues = JSON.parse($choose.attr('data-width-values') || '[]');
    if (!widthValues.length) return;
    if (!$.trim($(this).val())) {
      $choose.closest('.product__wrap').find('.exact-prop').first().val('');
      return;
    }

    var snappedWidth = closestNumber(widthValues, $(this).val());
    $choose.find('.hidden-input-width').val(snappedWidth);
    $choose.closest('.product__wrap').find('.exact-prop').first().val($.trim($(this).val()) + 'CM');
    updateFixedDepthSelect($choose);
  });

  $(document).on('change', '.product__choose-fixed-depth .fixed-option-select', function () {
    var $choose = $(this).closest('.product__choose-fixed-depth');
    updateFixedDepthSelect($choose);
  });

  $(function () {
    $('.product__choose-fixed-depth').each(function () {
      var $choose = $(this);
      var widthValues = JSON.parse($choose.attr('data-width-values') || '[]');
      if (widthValues.length) {
        var snappedWidth = closestNumber(widthValues, $choose.find('.input-width').val());
        $choose.find('.hidden-input-width').val(snappedWidth);
        $choose.closest('.product__wrap').find('.exact-prop').first().val($.trim($choose.find('.input-width').val()) + 'CM');
      }
      updateFixedDepthSelect($choose);
    });
  });
 
 
// MTM option image cards: force price refresh on selection
$(document).on('change', '.mtm-option-input', function () {
  var $scope = $(this).closest('.product__wrap');
  var $choose = $scope.find('.product__choose-mtm-three').first();
  if ($choose.length && typeof updateMtmThreePrice === 'function') {
    updateMtmThreePrice($choose);
  }
});

